<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px">
        <v-layout row style="padding: 0px">
          <v-spacer></v-spacer>
          <v-btn fab dark small color="amber darken-2" @click="getData">
            <v-icon dark>play_arrow</v-icon>
          </v-btn>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="dateFromMenu"
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="dateFromMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        disable-initial-sort
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                header.value === queryParams.order ? 'active' : '',
                'text-xs-' + header.align,
              ]"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-left">
            {{
              props.item.company_name
                ? props.item.company_name.toUpperCase()
                : "--"
            }}
          </td>
          <td class="text-xs-left">
            {{
              props.item.terminal_name
                ? props.item.terminal_name.toUpperCase()
                : "--"
            }}
          </td>
          <td class="text-xs-left">
            {{
              props.item.first_name && props.item.last_name
                ? `${props.item.first_name.toUpperCase()} ${props.item.last_name.toUpperCase()}`
                : "--"
            }}
          </td>
          <td class="text-xs-left">
            {{ props.item.card_no ? props.item.card_no : "--" }}
          </td>
          <td class="text-xs-left">
            {{
              props.item.sold_date
                ? props.item.sold_date.toUpperCase().substr(0, 10)
                : "--"
            }}
          </td>
          <td class="text-xs-left">
            {{
              props.item.registered_date
                ? props.item.registered_date.toUpperCase().substr(0, 10)
                : "--"
            }}
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/MicroServices";
import XLSX from "xlsx";
import DetailsContainer from "@/components/details_container/CardExceptionContainer";
import moment from "moment";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      title: "Sold vs Same Day Registered Card",
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      dateFrom: this.$dateFormat(new Date(), "YYYY-MM-DD"),
      dateTo: this.$dateFormat(new Date(), "YYYY-MM-DD"),

      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Company Name",
          align: "left",
          value: "company_name",
          sortable: false,
        },
        {
          text: "Terminal Name",
          align: "left",
          value: "terminal_name",
          sortable: true,
        },
        {
          text: "Employee Name",
          align: "left",
          value: "employee",
          sortable: true,
        },
        {
          text: "Card Number",
          align: "left",
          value: "card_number",
          sortable: true,
        },
        {
          text: "Sold Date",
          align: "left",
          value: "sold_date",
          sortable: false,
        },
        {
          text: "Registration Date",
          align: "left",
          value: "registration_date",
          sortable: false,
        },
      ],
      items: [],
      queryParams: {
        search: null,
        offset: 0,
        date_from: null,
        date_to: null,
      },
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {},
  created: async function() {},
  methods: {
    async getData() {
      this.$store.dispatch("startLoading");

      const body = {
        date: `${this.dateFrom} 00:00:00`,
      };

      try {
        const response = (await Services.getCardRegistered(body)).data;

        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
        this.$infoBar({
          type: "error",
          text: error.response.data.message || "Server Error",
        });
      }

      this.$store.dispatch("endLoading");
    },
    refreshData() {
      this.dateFrom = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(new Date(), "YYYY-MM-DD");
      this.getData(true);
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();
      // header.pop();
      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(
          this.items[e].company_name
            ? this.items[e].company_name.toUpperCase()
            : "--"
        );
        theItem.push(
          this.items[e].terminal_name
            ? this.items[e].terminal_name.toUpperCase()
            : "--"
        );
        theItem.push(
          this.items[e].first_name && this.items[e].last_name
            ? this.items[e].first_name.toUpperCase() +
                " " +
                this.items[e].last_name.toUpperCase()
            : "--"
        );
        theItem.push(this.items[e].card_no);
        theItem.push(
          this.items[e].sold_date ? this.items[e].sold_date.substr(0, 10) : 0
        );
        theItem.push(
          this.items[e].registered_date
            ? this.items[e].registered_date.substr(0, 10)
            : 0
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.form {
  padding: 0px 5px 10px 5px;
  border: 2px solid gray;
  border-radius: 5px;
}
.form:hover {
  border: 2px solid black;
}
#styled-input {
  height: 10px !important;
  font-size: 10pt !important;
}
</style>
